import { AsyncPipe, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, Component, ChangeDetectionStrategy, Input } from '@angular/core';
import * as i1 from '@taiga-ui/core';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { TUI_EDITOR_TOOLBAR_TEXTS, TUI_EDITOR_OPTIONS } from '@taiga-ui/editor/common';
import { TuiTiptapEditorService } from '@taiga-ui/editor/directives';
import { map } from 'rxjs';
function TuiDetailsRemove_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("click", function TuiDetailsRemove_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.removeDetails());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const text_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !!i0.ɵɵpipeBind1(1, 4, ctx_r1.disabled$))("iconStart", ctx_r1.options.icons.detailsRemove)("tuiHint", text_r3.removeDetails);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", text_r3.removeDetails, "\n");
  }
}
let TuiDetailsRemove = /*#__PURE__*/(() => {
  class TuiDetailsRemove {
    constructor() {
      this.localEditor = null;
      this.injectionEditor = inject(TuiTiptapEditorService, {
        optional: true
      });
      this.texts$ = inject(TUI_EDITOR_TOOLBAR_TEXTS);
      this.options = inject(TUI_EDITOR_OPTIONS);
      this.disabled$ = null;
    }
    set inputEditor(value) {
      this.localEditor = value;
      this.initStream();
    }
    ngOnInit() {
      this.initStream();
    }
    removeDetails() {
      this.editor?.removeDetails();
    }
    get editor() {
      return this.injectionEditor ?? this.localEditor;
    }
    initStream() {
      this.disabled$ = this.editor?.isActive$('details').pipe(map(isActive => !isActive)) ?? null;
    }
    static {
      this.ɵfac = function TuiDetailsRemove_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiDetailsRemove)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiDetailsRemove,
        selectors: [["tui-details-remove"]],
        inputs: {
          inputEditor: [0, "editor", "inputEditor"]
        },
        decls: 2,
        vars: 3,
        consts: [["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 3, "disabled", "iconStart", "tuiHint", "click", 4, "ngIf"], ["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 3, "click", "disabled", "iconStart", "tuiHint"]],
        template: function TuiDetailsRemove_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TuiDetailsRemove_button_0_Template, 3, 6, "button", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.texts$));
          }
        },
        dependencies: [AsyncPipe, NgIf, TuiButton, i1.TuiHintDirective, i1.TuiHintDescribe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiDetailsRemove;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDetailsRemove };
